__turbopack_context__.v({
  "animationBackground": "zzNaWG_animationBackground",
  "pulse-background": "zzNaWG_pulse-background",
});
